<template>
  <div>
    <full-calendar
      ref="calendar"
      :event-sources="eventSources"
      :config="calendarConfig"
      :events="calendarEvents"
    ></full-calendar>
  </div>
</template>

<script>
  'use strict'

  import { FullCalendar } from 'vue-full-calendar'
  import 'fullcalendar/dist/fullcalendar.min.css'

  export default {

    name: 'VueCalendar',

    components:
    {
      FullCalendar
    },

    props:
    {
      events: {
        type: Array,
        default: null,
        required: false
      },
      config: {
        type: Object,
        default: null,
        required: false
      }
    },

    data: () => ({
      calendarEvents: [],
      calendarConfig: [],
      selectedTool: [],
      lastClickTime: 0,
      clickTimer: null
    }),

    created () {
      this.calendarEvents = this.events || this.calendarEvents
      this.calendarConfig = {
        eventRender: function (event, element) {
          // console.log('eventRender', event)
        },
        drop: function (event) {
          // console.log('drop', event)
        },
        dayClick: (date, jsEvent, view) => {
          // console.log('dayClick', date, jsEvent, view)
        },
        eventClick: (event) => {
          // console.log('eventClick', event)
          let thisClickTime = new Date().getTime()

          let timeSinceLastClick = thisClickTime - this.lastClickTime

          this.lastClickTime = thisClickTime

          if (timeSinceLastClick < 300) {
            clearInterval(this.clickTimer)
            this.$emit('event-double-click', event)
          } else {
            this.clickTimer = setInterval(() => {
              this.$emit('event-click', event)
              clearInterval(this.clickTimer)
            }, 300)
          }
        },
        select: (startDate, endDate) => {
          this.$emit('select', startDate, endDate)
        },
        validRange: (nowDate) => {
          // let range = {
          //   start: nowDate,
          //   end: nowDate.clone().add(2, 'months')
          // }
          // console.log('validRange', range)
          // return range
        },
        selectOverlap: function (event) {
          return event.rendering === 'background'
        },
        eventOverlap: function (stillEvent, movingEvent) {
          // console.log('eventOverlap', stillEvent, movingEvent)
          return stillEvent.allDay && movingEvent.allDay
        }
      }
      this.normalizeConfig()
    },

    watch: {
      events: {
        handler: function (val, oldVal) {
          this.calendarEvents = val
        },
        deep: true
      }
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeConfig () {
        for (let index in this.config) {
          this.calendarConfig[index] = this.config[index]
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      removeEvents () {
        this.$refs.calendar.calendar.removeEvents()
        this.$emit('remove-events')
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      renderEvent (event, stick) {
        this.$refs.calendar.$emit('render-event', event, (stick || false))
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      fireMethod (...options) {
        this.$refs.calendar.$emit(...options)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      refreshEvents () {
        this.$refs.calendar.$emit('refetch-events')
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      removeEvent (event) {
        this.$refs.calendar.$emit('remove-event', event)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      eventSelected (event) {
        // console.log('eventSelected', event)
        this.selected = event
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      eventCreated (...test) {
        // console.log('eventCreated', test)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAdd () { }
    },
    computed: {

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      eventSources () {
        const self = this
        // console.log('ssssssss')
        return [
          {
            events (start, end, timezone, callback) {
              // console.log(start, end, timezone, callback)
              setTimeout(() => {
                callback(self.events.filter(() => Math.random() > 0.5))
              }, 1000)
            }
          }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/vue-calendar.vue